import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
//Components
import { Numbers } from "@uaveiro/ui";
//Context
//import { StoreContext } from "../../context/StoreContext";

const NumbersTemplate = ({ data, match, ...props }) => {
  /* const {
    state: { activeColor }
  } = useContext(StoreContext);*/
  const { lang } = match.params;
  const content = useMemo(() => data[lang] || data, [data, lang]);
  return (
    <Numbers
      data={content}
      //backgroundColor={activeColor || backgroundColor}
      {...props}
    />
  );
};

NumbersTemplate.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  match: PropTypes.object
};

export default withRouter(NumbersTemplate);
